import {
  FETCH_USER_FAILURE,
  FETCH_USER_REQUEST,
  FETCH_USER_SUCCESS,
  LOGOUT_USER,
} from "../actions/userActions";

const initialState = {
  loading: false,
  user: {},
  error: "",
  status: null,
  isLoaded: false,
  authChecking: true,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_REQUEST:
      return {
        ...state,
        loading: true,
        isLoaded: false,
        error: "",
        status: null,
      };
    case FETCH_USER_SUCCESS:
      return {
        loading: false,
        isLoaded: true,
        user: action.payload.user,
        status: 200,
        error: "",
      };
    case FETCH_USER_FAILURE:
      return {
        loading: false,
        isLoaded: false,
        user: {},
        error: action.payload.error,
        status: action.payload.status,
      };
    case LOGOUT_USER:
      return { ...initialState, authChecking: false };
    default:
      return state;
  }
};

export default userReducer;
